<template>
  <canvas ref="canvas" />
</template>

<script>
import QRious from 'qrious';

export default {
  name: 'QrCode',
  props: {
    text: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 256,
    },
    color: {
      type: String,
      default: '#000',
    },
    bgColor: {
      type: String,
      default: '#FFF',
    },
    errorLevel: {
      type: String,
      default: 'H',
      validator: (value) => ['L', 'M', 'Q', 'H'].includes(value),
    },
  },
  data() {
    return {
      qr: null,
    };
  },
  watch: {
    text: 'render',
    size: 'render',
    color: 'render',
    bgColor: 'render',
    errorLevel: 'render',
  },
  mounted() {
    this.render();
  },
  methods: {
    render() {
      const options = {
        element: this.$refs.canvas,
        value: this.text || ' ',
        size: this.size,
        level: this.errorLevel,
        foreground: this.color,
        background: this.bgColor,
      };

      if (this.qr) {
        this.qr.set(options);
        return;
      }

      this.qr = new QRious(options);
    },
  },
};
</script>
